import { render, staticRenderFns } from "./works-card.vue?vue&type=template&id=e4001ba4&scoped=true&"
import script from "./works-card.vue?vue&type=script&lang=js&"
export * from "./works-card.vue?vue&type=script&lang=js&"
import style0 from "./works-card.vue?vue&type=style&index=0&id=e4001ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4001ba4",
  null
  
)

export default component.exports